.card {
  height: 100%;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  font-size: 24px;
  border-radius: var(--ant-border-radius-lg);
}

.trend {
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.value {
  margin: 8px 0;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--ant-color-text-heading);
}

.description {
  font-size: 12px;
  line-height: 1.5;
  color: var(--ant-color-text-tertiary);
}
